// Enums matching C# enumerations

export enum Roles {
  User = 1,
  Region = 2,
  Supervisor = 3,
  Administrator = 4,
}

export enum Forms {
  Environment = 1,
  AIS = 2,
  General = 3,
  Terroir = 4,
  Lobbying = 5,
}

export enum FormActions {
  Save = 1,
  Submit = 2,
  Validate = 3,
  ValidateRegion = 4,
  Reject = 5,
}

// Base types

export interface TimeFrame {
  timeFrameId: number
  year: number
  isLocked: boolean
}

export interface Currency {
  currencyId: number
  code: string | null
  name: string | null
  rates: CurrencyRate[]
}

export interface CurrencyRate {
  currencyRateId: number
  currencyId: number
  timeFrameId: number
  rate: number
}

export interface ParsedCurrencyRate {
  code: string
  nameFromExcel: string
  originalValue: number
  transformedRate: number
  matchedInDatabase: boolean
}

export interface CurrencyRateParseResult {
  rates: ParsedCurrencyRate[]
  warnings: string[]
}

export interface AzureBlobSettings {
  blobUri: string | null
  container: string | null
  sasToken: string | null
}

// Lookup types

export interface ActionOption {
  actionOptionId: number
  code: string | null
  name: string | null
}

export interface KpiProgress {
  kpiProgressId: number
  code: string | null
}

export interface EnergyType {
  energyTypeId: number
  name: string | null
}

export interface EnergyUnit {
  energyUnitId: number
  code: string | null
}

export interface GeographicReach {
  geographicReachId: number
  name: string | null
  isResponsible: boolean
}

export interface InterventionArea {
  interventionAreaId: number
  name: string | null
  isResponsible: boolean
}

export interface Target {
  targetId: number
  name: string | null
  isGloballyVisible: boolean
}

export interface EvaluationType {
  evaluationTypeId: number
  name: string | null
  isResponsible: boolean
}

export interface ResponsibleDrinkingInitiative {
  responsibleDrinkingInitiativeId: number
  name: string | null
  nameLocal: string | null
  nameEnglish: string | null
  interventionAreaId: number
  initiativeTypeId: number
  targetsForInitiative: TargetPerInitiative[]
}

export interface TargetPerInitiative {
  targetPerInitiativeId: number
  responsibleDrinkingInitiativeId: number
  targetId: number
  target: Target | null
}

export interface FormAisResponsibleDrinkingInitiativeType {
  formAisResponsibleDrinkingInitiativeTypeId: number
  name: string | null
}

export interface FormEnvironmentPartnershipType {
  formEnvironmentPartnershipTypeId: number
  name: string | null
  isDisabled: boolean
}

export interface FormTerroirProjectEcosystemsType {
  formTerroirProjectEcosystemsTypeId: number
  name: string | null
}

export interface FormTerroirOwnedAreaEcosystem {
  formTerroirOwnedAreaEcosystemId: number
  name: string | null
}
